import { Zap, ArrowUpRight, Phone, Mail } from "lucide-react";
import { COMPANY } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 pt-16 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <img
              src="/brand/electris-logo.png"
              alt="Electris d.o.o."
              className="h-16 md:h-20 w-auto object-contain drop-shadow-[0_0_24px_rgba(220,38,38,0.35)]"
            />
            <div className="mt-4 text-[10px] tracking-widest2 uppercase text-ink-muted">
              Obitelj Jalšovec · od 1950.
            </div>
            <p className="mt-6 text-sm text-ink-muted leading-relaxed max-w-md">
              Pouzdani elektroinstalateri u Varaždinu i okolici. Specijalizirani
              za poslovne, stambene i komercijalne objekte.
            </p>
            <div className="mt-6 text-xs text-ink-muted">
              <div>{COMPANY.address}</div>
              <div className="mt-1">{COMPANY.hours}</div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-widest2 text-brand mb-5">
              Navigacija
            </div>
            <ul className="space-y-3">
              {[
                ["#o-nama", "O nama"],
                ["#usluge", "Usluge"],
                ["#projekti", "Projekti"],
                ["#razdjelnici", "Razdjelnici"],
                ["#kontakt", "Kontakt"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="text-sm text-white hover:text-brand transition-colors inline-flex items-center gap-1.5 group"
                  >
                    {label}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-widest2 text-brand mb-5">
              Kontakt
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6 text-sm">
              {COMPANY.contacts.map((c) => (
                <li key={c.email}>
                  <div className="text-[10px] uppercase tracking-widest2 text-ink-muted">
                    {c.role}
                  </div>
                  <div className="font-display font-bold text-white mt-1">
                    {c.name}
                  </div>
                  <div className="mt-2 space-y-1 text-xs">
                    <a
                      href={`tel:${c.phoneIntl}`}
                      className="flex items-center gap-2 text-white hover:text-brand transition-colors"
                    >
                      <Phone size={11} /> {c.phone}
                    </a>
                    <a
                      href={`mailto:${c.email}`}
                      className="flex items-center gap-2 text-ink-muted hover:text-brand transition-colors break-all"
                    >
                      <Mail size={11} /> {c.email}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="py-10">
          <div
            aria-hidden
            className="font-display font-black text-white/[0.04] tracking-tightest leading-none text-[20vw] md:text-[15vw] select-none text-center"
          >
            ELECTRIS
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-ink-muted">
          <div>
            © {new Date().getFullYear()} Electris d.o.o. — Sva prava pridržana.
          </div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-brand pulse-red" />
            <span className="uppercase tracking-widest2">
              Tradicija struje od 1950.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
